import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { RewardUnlockStrategy } from '@brandclub/types';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CloseIcon from '@mui/icons-material/Close';
import { styled, useTheme, Icon, Backdrop } from '@mui/material';
import React, { useEffect } from 'react';
import { OutOfStockPill } from '../../BrandclubLanding/components/OutOfStockPill/OutOfStockPill.js';
import { RewardPillWithText } from '../../BrandclubLanding/components/RewardPill/RewardPillWithText.js';
import brandclub_colors from '../../colors/brandclubColors.js';
import { CampaignType } from '../../types/Campaign.js';
import '../../types/filters.js';
import '../../types/product.js';
import '../../types/RewardAmountType.js';
import '../../analytics/events.js';
import 'uuid';
import 'lodash/includes';
import { getEntityImage } from '../../utils/assetUtils.js';
import '../../utils/brandclubStoreConfigUtils.js';
import 'numeral';
import { formatMoney, getRetailerFromId } from '../../utils/stringUtils.js';
import '../../utils/broadcast.js';
import { getBuyOrViewProductMetaTag } from '../../utils/dataLayer.js';
import { TABLET_SCREEN_SIZE } from '../../utils/constants/Constants.js';
import 'awesome-phonenumber';
import 'lodash/isEqual';
import 'lodash/get';
import 'lodash/orderBy';
import { isProductEligibleForCheckout, getAddToBagText, getPurchaseRewardAmountForProduct, isProductOutOfStock } from '../../utils/productUtils.js';
import '../../api/graphQl/brand.js';
import '../../api/graphQl/product.js';
import '../Button/BackButton.js';
import { Button } from '../Button/Button.js';
import '../Button/CloseButton.js';
import '../Button/CustomDtcBagButton.js';
import { BuyBoxType } from './BuyBoxType.js';

var ProductPriceButton = styled(Button)({
    borderRadius: 999,
});
var ProductPrice = function (_a) {
    var productsToList = _a.productsToList, onOpenRetailerProductPageClick = _a.onOpenRetailerProductPageClick, onBuyClick = _a.onBuyClick, buyBoxType = _a.buyBoxType, _onExpandBuyBoxToggle = _a.onExpandBuyBoxToggle, customBagButtonStyle = _a.customBagButtonStyle, checkoutAllowedOfferType = _a.checkoutAllowedOfferType, props = __rest(_a, ["productsToList", "onOpenRetailerProductPageClick", "onBuyClick", "buyBoxType", "onExpandBuyBoxToggle", "customBagButtonStyle", "checkoutAllowedOfferType"]);
    var theme = useTheme();
    if (!(productsToList === null || productsToList === void 0 ? void 0 : productsToList.length)) {
        return null;
    }
    var showStickyBuyBox = buyBoxType === BuyBoxType.BuyBoxBottomSheetShort ||
        buyBoxType === BuyBoxType.BuyBoxBottomSheetExpanded ||
        buyBoxType === BuyBoxType.BuyBoxBottomSheetAlwaysExpanded ||
        buyBoxType === BuyBoxType.BuyBoxBottomSheetAlwaysExpandedWithoutBackdrop;
    var hideBackdrop = buyBoxType === BuyBoxType.BuyBoxBottomSheetAlwaysExpandedWithoutBackdrop;
    var canExpand = (productsToList === null || productsToList === void 0 ? void 0 : productsToList.length) > 1 && buyBoxType === BuyBoxType.BuyBoxBottomSheetShort;
    var isExpanded = buyBoxType === BuyBoxType.BuyBoxBottomSheetExpanded ||
        buyBoxType === BuyBoxType.BuyBoxBottomSheetAlwaysExpanded ||
        buyBoxType === BuyBoxType.BuyBoxBottomSheetAlwaysExpandedWithoutBackdrop;
    var fixedPosition = props.fixedPosition || buyBoxType === BuyBoxType.BuyBoxBottomSheetExpanded;
    var onExpandBuyBoxToggle = function () {
        if (canExpand || isExpanded) {
            _onExpandBuyBoxToggle === null || _onExpandBuyBoxToggle === void 0 ? void 0 : _onExpandBuyBoxToggle();
        }
    };
    useEffect(function () {
        var overflow = document.body.style.overflow;
        if (isExpanded) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = overflow;
        }
        return function () {
            document.body.style.overflow = overflow;
        };
    }, [isExpanded]);
    // this only renders if buyBoxType is BuyBoxBottomSheetExpanded or AboveTheFold
    var removeNonLiveCampaigns = function (campaign) {
        return campaign.filter(function (c) { return c.campaignStatus === 'live'; });
    };
    var render = function (products) {
        var topThreeProducts = products.slice(0, 3);
        var productListed = buyBoxType === BuyBoxType.BuyBoxBottomSheetAlwaysExpanded ? products : topThreeProducts;
        return (React.createElement(Details, null,
            React.createElement("div", { className: "product_price", style: isExpanded ? { padding: '15px 0 15px', gap: 20 } : {} },
                (theme === null || theme === void 0 ? void 0 : theme.dtc) && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "bar" }),
                    React.createElement("div", { className: "detail_title" }, "Choose a retailer"))),
                productListed.map(function (item, idx) {
                    var _a;
                    var _b, _c;
                    var hasActiveInstantReward = false;
                    for (var _i = 0, _d = removeNonLiveCampaigns((_b = item === null || item === void 0 ? void 0 : item.campaignRewards) !== null && _b !== void 0 ? _b : []); _i < _d.length; _i++) {
                        var campaignReward = _d[_i];
                        if ((campaignReward === null || campaignReward === void 0 ? void 0 : campaignReward.campaignType) === CampaignType.DailyDealsRewardCampaign ||
                            (campaignReward === null || campaignReward === void 0 ? void 0 : campaignReward.rewardUnlockStrategy) === RewardUnlockStrategy.Instant) {
                            hasActiveInstantReward = true;
                            break;
                        }
                    }
                    var rewardAmount = getPurchaseRewardAmountForProduct(item);
                    var rewardPercent = !!item.retailPrice && !!rewardAmount ? (rewardAmount * 100) / item.retailPrice : 0;
                    var isOutOfStock = isProductOutOfStock(item, checkoutAllowedOfferType);
                    return (React.createElement("div", { key: idx, className: "price_card" },
                        React.createElement("div", { className: "retailer_icon", onClick: function () {
                                onExpandBuyBoxToggle === null || onExpandBuyBoxToggle === void 0 ? void 0 : onExpandBuyBoxToggle();
                            } },
                            React.createElement("img", { loading: "lazy", alt: "retailer", src: getEntityImage(item.retailerId, 'retailer') })),
                        React.createElement("div", { style: { flex: 1 } },
                            React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between' } },
                                React.createElement("div", { className: "detail_retailer_price" },
                                    React.createElement("a", { href: item.retailerProductPageUrl, target: "_blank", onClick: function (e) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            onOpenRetailerProductPageClick(item);
                                        }, style: { textDecoration: 'none', color: theme.palette.primary.main } },
                                        React.createElement("div", { className: "name", style: {} }, getRetailerFromId(item.retailerId) || '')),
                                    React.createElement("div", { className: "price" }, formatMoney(item.retailPrice))),
                                React.createElement(ProductPriceButton, __assign({ sx: (_a = {
                                            minWidth: 82,
                                            borderRadius: (_c = theme === null || theme === void 0 ? void 0 : theme.globalButtonRadius) !== null && _c !== void 0 ? _c : 999,
                                            backgroundColor: (customBagButtonStyle === null || customBagButtonStyle === void 0 ? void 0 : customBagButtonStyle.bgColor) || '#f6f8fa',
                                            border: (customBagButtonStyle === null || customBagButtonStyle === void 0 ? void 0 : customBagButtonStyle.borderEnabled)
                                                ? "1px solid ".concat(customBagButtonStyle.borderColor)
                                                : 'none',
                                            color: (customBagButtonStyle === null || customBagButtonStyle === void 0 ? void 0 : customBagButtonStyle.textColor) || theme.palette.primary.main,
                                            width: 82,
                                            height: 35,
                                            fontSize: 14,
                                            paddingLeft: '16px',
                                            paddingRight: '16px',
                                            fontWeight: 600,
                                            margin: '10px 0',
                                            '&:hover': {
                                                color: (customBagButtonStyle === null || customBagButtonStyle === void 0 ? void 0 : customBagButtonStyle.textColor) || theme.palette.primary.main,
                                                backgroundColor: (customBagButtonStyle === null || customBagButtonStyle === void 0 ? void 0 : customBagButtonStyle.bgColor) || '#f6f8fa',
                                            },
                                            '&:active': {
                                                backgroundColor: theme.palette.primary.main,
                                                color: '#fff',
                                            }
                                        },
                                        _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                                            fontSize: 14,
                                            height: 32,
                                        },
                                        _a["@media screen and (max-width: 400px)"] = {
                                            maxWidth: 200,
                                        },
                                        _a) }, getBuyOrViewProductMetaTag(isProductEligibleForCheckout(item, checkoutAllowedOfferType) ? 'buy' : 'view', getRetailerFromId(item.retailerId) || '', item.name, item.id, item.stacklineSku, window.location.href, item.retailPrice), { onClick: function (e) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if (isProductEligibleForCheckout(item, checkoutAllowedOfferType)) {
                                            onBuyClick(item);
                                        }
                                        else {
                                            onOpenRetailerProductPageClick(item);
                                        }
                                    } }), getAddToBagText(item, checkoutAllowedOfferType))),
                            isOutOfStock ? React.createElement(OutOfStockPill, { pillContainerStyle: {} }) : null,
                            rewardAmount && !isOutOfStock ? (React.createElement(RewardPillWithText, { pillContainerStyle: isExpanded ? { padding: '1px 6.5px', fontSize: 11 } : {}, rewardAmount: rewardAmount, rewardPercent: rewardPercent, rewardCampaignType: hasActiveInstantReward
                                    ? CampaignType.DailyDealsRewardCampaign
                                    : CampaignType.PurchaseRewardCampaign })) : null)));
                }))));
    };
    if (showStickyBuyBox) {
        return (React.createElement(FixedToBottomDetails, { hideBackdrop: hideBackdrop, isExpanded: isExpanded, fixedPosition: fixedPosition, expandToggle: onExpandBuyBoxToggle }, isExpanded ? (render(productsToList)) : (React.createElement(Details, null,
            React.createElement("div", { className: "product_price", style: { padding: 0, paddingBottom: 5 } }, [productsToList[0]].map(function (item, idx) {
                var _a;
                var _b, _c;
                // hasActiveInstantReward on the item is not reliable on its own, so we need to check the campaign rewards
                var hasActiveInstantReward = item.hasActiveInstantReward;
                for (var _i = 0, _d = removeNonLiveCampaigns((_b = item === null || item === void 0 ? void 0 : item.campaignRewards) !== null && _b !== void 0 ? _b : []); _i < _d.length; _i++) {
                    var campaignReward = _d[_i];
                    if ((campaignReward === null || campaignReward === void 0 ? void 0 : campaignReward.campaignType) === CampaignType.DailyDealsRewardCampaign ||
                        (campaignReward === null || campaignReward === void 0 ? void 0 : campaignReward.rewardUnlockStrategy) === RewardUnlockStrategy.Instant) {
                        hasActiveInstantReward = true;
                        break;
                    }
                }
                var rewardPercent = !!item.retailPrice && !!(item === null || item === void 0 ? void 0 : item.totalRewardAmount)
                    ? (item.totalRewardAmount * 100) / item.retailPrice
                    : 0;
                return (React.createElement("div", { key: idx, className: "price_card", style: { flexDirection: 'column', alignItems: 'center' } },
                    React.createElement("div", { style: { display: 'flex', width: '100%' } },
                        React.createElement("div", { style: { marginRight: 7 }, className: "retailer_icon", onClick: function () {
                                onExpandBuyBoxToggle === null || onExpandBuyBoxToggle === void 0 ? void 0 : onExpandBuyBoxToggle();
                            } },
                            React.createElement("img", { loading: "lazy", alt: "retailer", src: getEntityImage(item.retailerId, 'retailer') })),
                        React.createElement("div", { style: { flex: 1 } },
                            React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
                                canExpand ? (React.createElement(ArrowBackIosNewIcon, { style: { transform: 'rotate(90deg) scale(0.5)' }, onClick: function () {
                                        onExpandBuyBoxToggle === null || onExpandBuyBoxToggle === void 0 ? void 0 : onExpandBuyBoxToggle();
                                    } })) : null,
                                React.createElement(Button, { style: {
                                        borderRadius: (_c = theme === null || theme === void 0 ? void 0 : theme.globalButtonRadius) !== null && _c !== void 0 ? _c : 999,
                                    }, sx: (_a = {
                                            backgroundColor: theme.palette.primary.main,
                                            width: '100%',
                                            height: 44,
                                            fontSize: 17,
                                            fontWeight: 600,
                                            margin: '5px 0 10px 10px'
                                        },
                                        _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                                            fontSize: 14,
                                        },
                                        _a["@media screen and (max-width: 400px)"] = {
                                            width: '100%',
                                        },
                                        _a), onClick: function (e) {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if (isProductEligibleForCheckout(item, checkoutAllowedOfferType)) {
                                            onBuyClick(item);
                                        }
                                        else {
                                            onOpenRetailerProductPageClick(item);
                                        }
                                    } }, "".concat(getAddToBagText(item, checkoutAllowedOfferType)) +
                                    (item.retailPrice !== undefined ? '  \u2022  ' + formatMoney(item.retailPrice) : ''))))),
                    (item === null || item === void 0 ? void 0 : item.totalRewardAmount) ? (React.createElement(RewardPillWithText, { containerStyle: { marginLeft: 19 }, rewardAmount: item.totalRewardAmount, rewardPercent: rewardPercent, pillContainerStyle: isExpanded ? { height: 22, width: '60px' } : {}, rewardCampaignType: hasActiveInstantReward
                            ? CampaignType.DailyDealsRewardCampaign
                            : CampaignType.PurchaseRewardCampaign })) : null));
            }))))));
    }
    return render(productsToList);
};
var Details = styled('div', {
    label: 'ProductPriceDetails',
})(function (_a) {
    var _b, _c;
    var theme = _a.theme;
    return ({
        '.product_price': (_b = {
                padding: '40px 35px'
            },
            _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                padding: '40px 0px',
                paddingTop: 0,
                width: '100%',
            },
            _b.display = 'flex',
            _b.flexDirection = 'column',
            _b.gap = 30,
            _b['.bar'] = {
                display: 'block !important',
                width: '31px !important',
                height: '4px !important',
                borderRadius: '10px !important',
                backgroundColor: '#d8d8d8 !important',
                margin: '0 auto -2.5px',
                marginTop: '-8px',
            },
            _b['.detail_title'] = {
                color: theme.palette.primary.main,
                margin: 'unset',
                fontSize: '22px !important',
                fontWeight: '600 !important ',
                textAlign: 'center !important',
            },
            _b['.price_card'] = {
                display: 'flex',
                '.retailer_icon': {
                    width: '50px',
                    height: '50px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '20px',
                    marginTop: '5px',
                    img: {
                        maxWidth: '100%',
                        maxHeight: '100%',
                    },
                },
                '.detail_retailer_price': {
                    flex: 1,
                    marginBottom: 5,
                    div: {
                        width: 'fit-content',
                    },
                    '.name': {
                        fontSize: 14,
                        fontWeight: 600,
                    },
                    '.price': (_c = {
                            fontSize: 24,
                            fontWeight: 600,
                            color: theme.palette.primary.main
                        },
                        _c["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                            fontSize: 22,
                        },
                        _c),
                },
            },
            _b),
    });
});
var FixedToBottomDetails = function (_a) {
    var children = _a.children, isExpanded = _a.isExpanded, expandToggle = _a.expandToggle, hideBackdrop = _a.hideBackdrop, fixedPosition = _a.fixedPosition;
    var theme = useTheme();
    var FixedComponent = function (_a) {
        var ch = _a.children;
        return (React.createElement(React.Fragment, null,
            hideBackdrop ? null : (React.createElement(Backdrop, { open: isExpanded, onClick: function () {
                    expandToggle === null || expandToggle === void 0 ? void 0 : expandToggle();
                }, sx: {
                    zIndex: 5,
                    backgroundColor: brandclub_colors.darkBlue3,
                } })),
            React.createElement("div", { style: {
                    position: fixedPosition ? 'fixed' : 'relative',
                    zIndex: 100,
                    width: '100%',
                    padding: '10px 20px 18px 20px',
                    bottom: 0,
                    left: 0,
                    background: '#fff',
                    borderTop: '1px solid #dcdddc',
                    boxSizing: 'border-box',
                    minHeight: 121,
                    transition: 'all 0.3s ease-in-out',
                    borderTopLeftRadius: isExpanded ? 20 : 0,
                    borderTopRightRadius: isExpanded ? 20 : 0,
                } }, ch)));
    };
    return isExpanded && !(theme === null || theme === void 0 ? void 0 : theme.dtc) ? (React.createElement(FixedComponent, null,
        React.createElement(React.Fragment, null,
            React.createElement(Icon, { sx: function (theme) { return ({
                    paddingTop: 0,
                    float: 'right',
                    cursor: 'pointer',
                    color: theme.palette.primary.main,
                }); }, className: "close", onClick: function () {
                    expandToggle === null || expandToggle === void 0 ? void 0 : expandToggle();
                } },
                React.createElement(CloseIcon, null)),
            children))) : (React.createElement(FixedComponent, null,
        " ",
        children,
        " "));
};

export { ProductPrice };
//# sourceMappingURL=ProductPrice.js.map
